'use es6';

import quickFetch from 'quick-fetch';
import Raven from 'raven-js';

const fetchWithEarlyRequester = (fallbackFetch, requestId) => {
  const earlyRequest = quickFetch.getRequestStateByName(requestId);

  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(requestId);
      });
      earlyRequest.onError(() => {
        fallbackFetch().then(resolve).catch(error => {
          Raven.captureException(error, {
            extra: {
              fallbackFetch,
              requestId
            }
          });
          reject(error);
        });
        quickFetch.removeEarlyRequest(requestId);
      });

      if (window.newrelic) {
        window.newrelic.setCustomAttribute(`${requestId}-early-request-used`, Boolean(earlyRequest.finished));
      }
    });
  }

  return fallbackFetch();
};

export default fetchWithEarlyRequester;